import {
  Component
} from '@angular/core';
import { viewLoader } from '../../../assets/animations/animations';
import { MeshGradientComponent } from '../mesh-gradient/mesh-gradient.component';

@Component({
  selector: 'app-blob',
  templateUrl: './blob.component.html',
  styleUrls: ['./blob.component.scss'],
  animations: [viewLoader],
  imports: [
    MeshGradientComponent,
  ],
})
export class BlobComponent {
  
}
